import jq from 'jquery';
import doc_ready from 'document-ready';

function updatePartecipantAnswer() {
    var row = (((this.parentElement).parentElement).parentElement).parentElement;
    var new_status = this.getAttribute('data-status');
    var pid = row.getAttribute('data-person');
    var stat = document.getElementById('stat_' + pid);
    var act_id = document.getElementById('act_id').value;
    var post_data = new FormData()
    post_data.append('activity', act_id);
    post_data.append('person', pid);
    post_data.append('answer', new_status);
    window.axios.post('/index.php?option=com_asdgest&view=activity&format=raw&layout=answer', post_data)
        .then( response => {
            if (row.outerHTML) { //if outerHTML is supported
                row.outerHTML = response.data.message;
            }
            else { //weird but crossbrowsered trick
                console.log('ERRORE AGGIORNAMENTO', result);
                var tmpObj = document.createElement("div");
                var tbody = row.parentNode;
                tmpObj.innerHTML = 'Errore';
                tbody.replaceChild(tmpObj, row);
                tbody.innerHTML = tbody.innerHTML.replace('<div><p>qualcosa non funziona</p>/div>', (result.html).trim());
            }


            // jq('.tooltipped').tooltip();
        })
        .catch( error => {
            console.log('Error signaling answer to server', error);
            alert('Aggiornamento partecipazione non riuscito');
        });
}

function activityAnswer () {
    doc_ready( () => {
        var ddstatuses = document.getElementsByClassName('ddstatus');
        for (var i = 0; i < ddstatuses.length; i++) {
            ddstatuses[i].addEventListener('click', updatePartecipantAnswer);
        }
    })
}

export default activityAnswer;

